import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Ingrese un email válido'),
  password: z.string().min(1, 'La contraseña es requerida'),
});

export const empleadoSchema = z.object({
  email: z.string().email('Ingrese un email válido'),
  dni: z.string().min(6, 'DNI debe tener al menos 6 caracteres'),
  password: z.string().min(4, 'La contraseña debe tener al menos 4 caracteres'),
  firstName: z.string().min(2, 'El nombre debe tener al menos 2 caracteres'),
  lastName: z.string().min(2, 'El apellido debe tener al menos 2 caracteres'),
});

export const eventoCreateSchema = z.object({
  fechaHoraEvento: z.string().min(1, 'Seleccione fecha y hora'),
  precioTotalDelEvento: z.number().positive('El precio debe ser mayor a 0'),
  senaPagada: z.number().min(0).optional(),
  cantidadInvitados: z.number().int().positive('Debe haber al menos 1 invitado'),
  correoResponsable: z.string().email('Ingrese un email válido'),
  telefonoResponsable: z.string().optional(),
  talleCumplaniero: z.string().optional(),
  asistenciaMenores: z.boolean().optional(),
  tematica: z.string().min(2, 'La temática debe tener al menos 2 caracteres'),
});

export const entradaCreateSchema = z.object({
  nombreEntrada: z.string().min(2, 'El nombre debe tener al menos 2 caracteres'),
  tipoPago: z.string().min(1, 'Seleccione un tipo de pago'),
  precio: z.number().positive('El precio debe ser mayor a 0'),
  duracion: z.number().positive('La duración debe ser mayor a 0'),
  cantidadEntradas: z.number().int().positive('Debe haber al menos 1 entrada'),
});

export const perfilSchema = z.object({
  firstName: z.string().min(2, 'El nombre debe tener al menos 2 caracteres'),
  lastName: z.string().min(2, 'El apellido debe tener al menos 2 caracteres'),
  password: z.string().refine((v) => v === '' || v.length >= 4, 'La contraseña debe tener al menos 4 caracteres'),
});

export const tomarEntradaSchema = z.object({
  nombreAdultoResponsable: z.string().min(3, 'Ingrese el nombre del adulto responsable'),
  dniAdultoResponsable: z.string().min(6, 'El DNI debe tener al menos 6 caracteres'),
  correoAdultoResponsable: z.string().email('Ingrese un email válido'),
  tipoPago: z.string().min(1, 'Seleccione un tipo de pago'),
  aceptaCondiciones: z.literal(true, { errorMap: () => ({ message: 'Debe aceptar los términos y condiciones' }) }),
});

export const menorSchema = z.object({
  nombre: z.string().min(2, 'Ingrese el nombre del menor'),
  documento: z.string().min(4, 'Ingrese el documento del menor'),
});
